import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import { PropType } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AcButton',
  props: {
  block: {
    type: Boolean,
    default: false
  },
  icon: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  variant: {
    type: String as PropType<'tonal' | 'outlined' | 'text'>,
    default: null
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["acButton", [
      __props.variant ? `-${__props.variant}` : '',
      __props.icon ? `-icon` : '',
      __props.block ? `-block` : '',
      __props.disabled ? `-disabled` : ''
    ]]),
    disabled: __props.disabled
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})